import commonUtil from "../tools/common";
export default function (dateVal) {
  // 时间格式化
  return commonUtil.formatDate(dateVal)
}
